<template>
  <v-app>
    <v-container v-if="$route.name === 'UserProject'">
      <v-row v-if="doc">
        <v-col
          cols="4"
          class=""
          v-for="ex in doc.exercisesOrder"
          :key="`${ex.id}-${Date.now() + Math.random()}`"
        >
          <admin-card
            :path="`/users/project/${id}/${ex.slug}`"
            :title="ex.title"
            type="Exercise"
            :description="ex.description"
            button="Start"
          ></admin-card>
        </v-col>
      </v-row>
      <v-row v-if="doc && doc.showResults">
        <v-col cols="12">
          <h2>Results</h2>
        </v-col>
        <v-col cols="4">
          <admin-card
            :dark="true"
            :path="`/users/project/${id}/results`"
            title="Results"
            type="Summary"
            description="Review the summaries from the workshop"
            button="View"
          ></admin-card>
        </v-col>
      </v-row>
    </v-container>
    <router-view></router-view>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { store } from "@/store";
import { AdminCard } from "@/components/core";
const fb = require("@/firebaseConfig.js");
export default {
  name: "UserProject",
  components: {
    AdminCard,
  },
  props: {
    id: String || Number,
  },
  data() {
    return {
      projects: null,
      doc: null,
      unsubscribe: null,
      unsubscribePlanes: null,
    };
  },
  mounted() {
    this.getProject();
    this.subscribePlanes();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.unsubscribePlanes) this.unsubscribePlanes();
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  beforeRouteUpdate(to, from, next) {
    this.getProject();
    next();
  },
  methods: {
    getProject() {
      if (!this.id) return;
      console.log("get project");
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      let ref = fb.projectsCollection.where("id", "==", this.id);

      this.unsubscribe = ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.doc = items[0];
        if (!this.doc) return;
        store.commit("setCurrentProject", this.doc.title);
        store.commit("setCurrentProjectModel", this.doc);
        store.commit("setCurrentExercises", this.doc.exercisesOrder);
      });
    },
    subscribePlanes() {
      if (this.unsubscribePlanes) {
        this.unsubscribePlanes();
        this.unsubscribePlanes = null;
      }
      this.unsubscribePlanes = fb.planesCollection.onSnapshot((snap) => {
        const planes = [];
        snap.forEach((docSnap) => planes.push(docSnap.data()));
        store.commit("setCurrentPlanes", planes);
      });
    },
  },
};
</script>
